// extracted by mini-css-extract-plugin
export default {"flagContainer":"LWGkSHb_lhpc5XRQztly","flag":"Km8Z9mxKGW7WyVaVE1T9","leftFlag":"pfQh2bgFI6SuIMVx2nqr","rightFlag":"lYxPpNh51bGxKw7Z3AAs"};